import { useMemo } from 'react';
import { AdviseCurrentSupplier, AdviseSupplierInvoice } from '../../../../types/advise';
import { engagementPriceCategories } from '../pricing';
import { useEngagementEditor } from './EngagementEditorContext';
import { InvoiceLineItemsTable } from './InvoiceLineItemsTable';
import { ManualLineItemsTable } from './ManualLineItemsTable';
import { MonthlyTotalField } from './MonthlyTotalField';
import { ManualSpendDraft } from './useManualSpendDraft';

export interface ManualSpendInputProps {
  supplier: AdviseCurrentSupplier;
  invoice: AdviseSupplierInvoice | null;
  draft: ManualSpendDraft;
}

export const ManualSpendInput = ({ supplier, invoice, draft }: ManualSpendInputProps) => {
  const { engagement, canEdit } = useEngagementEditor();
  const categories = useMemo(() => engagementPriceCategories(engagement), [engagement]);
  if (draft.entry === 'monthly_total') {
    return (
      <MonthlyTotalField
        total={draft.total}
        canEdit={canEdit}
        error={draft.error}
        disabled={draft.saving}
        onChange={draft.setTotal}
      />
    );
  }
  if (canEdit) {
    return (
      <ManualLineItemsTable
        draft={draft}
        categories={categories}
      />
    );
  }
  return (
    <InvoiceLineItemsTable
      lines={invoice ? invoice.line_items : supplier.line_items}
      categories={categories}
      canEdit={false}
      onScopeChange={() => undefined}
      onCategoryChange={() => undefined}
    />
  );
};
